import ScrollMagic from 'scrollmagic';
import debugAddIndicators from './debug.addIndicators.js';

//TODO: exclude debugAddIndicators usage from production build
debugAddIndicators(ScrollMagic);

export { ScrollMagic };
